import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const stepsSlice = createSlice({
  name: "steps",
  initialState,
  reducers: {},
});

export const {} = stepsSlice.actions;
export default stepsSlice.reducer;
